export const FORM_PLATFORM_NAMESPACE = 'wix.form_platform.form';

//# sourceMappingURL=namespaces.js.map